'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AdvancedSearchFilter = require('./AdvancedSearchFilter');

var _AdvancedSearchFilter2 = _interopRequireDefault(_AdvancedSearchFilter);

var _Input = require('./../Input');

var _Input2 = _interopRequireDefault(_Input);

var _Button = require('./../Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Close = function Close() {
  return _react2.default.createElement(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 320 512' },
    _react2.default.createElement('path', { d: 'M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z' })
  );
};

var AdvancedSearch = function (_PureComponent) {
  _inherits(AdvancedSearch, _PureComponent);

  function AdvancedSearch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AdvancedSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdvancedSearch.__proto__ || Object.getPrototypeOf(AdvancedSearch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mustContain: '',
      canContain: '',
      mustNotContain: ''
    }, _this.componentDidUpdate = function (oldProps) {
      var prevExpandedAdvancedSearch = oldProps.expandedAdvancedSearch,
          prevAdvancedSearchIsActive = oldProps.advancedSearchIsActive;
      var _this$props = _this.props,
          currExpandedAdvancedSearch = _this$props.expandedAdvancedSearch,
          currAdvancedSearchIsActive = _this$props.advancedSearchIsActive;


      if (prevAdvancedSearchIsActive === false && currAdvancedSearchIsActive === true) {
        _this.splitTags();
        return;
      }

      if (prevExpandedAdvancedSearch === currExpandedAdvancedSearch) return;

      if (currExpandedAdvancedSearch) {
        window.addEventListener('keydown', _this.onKeyDownAdvancedSearch);
      } else {
        window.removeEventListener('keydown', _this.onKeyDownAdvancedSearch);
      }
    }, _this.componentWillUnmount = function () {
      window.removeEventListener('keydown', _this.onKeyDownAdvancedSearch);
    }, _this.onKeyDownAdvancedSearch = function (_ref2) {
      var key = _ref2.key;

      if (key === 'Escape') {
        _this.props.toggleAdvancedSearch();
      } else if (key === 'Enter') {
        _this.doAdvancedSearch();
      }
    }, _this.splitTags = function () {
      var tags = _this.props.tags;


      var mustContain = '';
      var canContain = '';
      var mustNotContain = '';

      tags.forEach(function (tag) {
        if (tag[0] === '+') {
          mustContain = '' + mustContain + tag.substr(1, tag.length) + ', ';
        } else if (tag[0] === '-') {
          mustNotContain = '' + mustNotContain + tag.substr(1, tag.length) + ', ';
        } else {
          canContain = '' + canContain + tag + ', ';
        }
      });

      _this.setState({ mustContain: mustContain, mustNotContain: mustNotContain, canContain: canContain });
    }, _this.preventMistyping = function (str) {
      // the last letters can not be two comma  (ex: ',,' and ',  ,' are incorrect)
      var noWhiteSpace = str.replace(/\s/g, '');
      var length = noWhiteSpace.length;
      if (noWhiteSpace[length - 2] === ',' && noWhiteSpace[length - 1] === ',') return 0;
      return 1;
    }, _this.updateInputValue = function (label) {
      return function (_ref3) {
        var value = _ref3.value;

        if (!_this.preventMistyping(value)) return;
        _this.setState(_defineProperty({}, label, value));
      };
    }, _this.deleteAdvancedSearchInput = function (label) {
      return function () {
        _this.setState(_defineProperty({}, label, ''));
      };
    }, _this.advancedSearchInputToTags = function (inputValue, operator) {
      var cleanInputValue = _this.props.cleanInputValue;


      var tags = inputValue.split(',').filter(function (tag) {
        return tag.trim() !== '';
      }).map(function (tag) {
        return '' + operator + cleanInputValue(tag);
      });

      return tags;
    }, _this.doAdvancedSearch = function () {
      var doAdvancedSearch = _this.props.doAdvancedSearch;
      var _this$state = _this.state,
          mustContain = _this$state.mustContain,
          canContain = _this$state.canContain,
          mustNotContain = _this$state.mustNotContain;


      var mustContainTags = _this.advancedSearchInputToTags(mustContain, '+');
      var mustNotContainTags = _this.advancedSearchInputToTags(mustNotContain, '-');
      var canContainTags = _this.advancedSearchInputToTags(canContain, '');

      var tags = [].concat(_toConsumableArray(mustContainTags), _toConsumableArray(canContainTags), _toConsumableArray(mustNotContainTags));
      doAdvancedSearch(tags);
    }, _this.onEnterPress = function () {
      _this.doAdvancedSearch();
      window.removeEventListener('keydown', _this.onKeyDownAdvancedSearch);
    }, _this.onKeyPress = function (_ref4) {
      var key = _ref4.key;

      if (key === 'Escape') {
        _this.props.toggleAdvancedSearch();
        window.removeEventListener('keydown', _this.onKeyDownAdvancedSearch);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdvancedSearch, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          mustContain = _state.mustContain,
          canContain = _state.canContain,
          mustNotContain = _state.mustNotContain;
      var _props = this.props,
          autoFocus = _props.autoFocus,
          disabled = _props.disabled,
          expandedAdvancedSearch = _props.expandedAdvancedSearch,
          lexique = _props.lexique,
          filters = _props.filters,
          onChangeFilters = _props.onChangeFilters;


      return _react2.default.createElement(
        'div',
        { className: expandedAdvancedSearch ? 'search-bar-advanced-wrapper search-bar-advanced-expanded' : 'search-bar-advanced-wrapper' },
        _react2.default.createElement(
          'div',
          { className: !expandedAdvancedSearch ? 'search-bar-advanced search-bar-advanced--hidden' : 'search-bar-advanced' },
          _react2.default.createElement(
            'div',
            { className: 'search-bar-advanced-row-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'search-bar-advanced-row' },
              _react2.default.createElement(
                'div',
                { className: 'search-bar-advanced-label' },
                ' ',
                lexique.mustContain
              ),
              _react2.default.createElement(
                'div',
                { className: 'search-bar-advanced-input' },
                _react2.default.createElement(_Input2.default, {
                  autoFocus: autoFocus,
                  value: mustContain,
                  onChange: this.updateInputValue('mustContain'),
                  onEnterPress: this.onEnterPress,
                  onKeyPress: this.onKeyPress,
                  disabled: disabled,
                  noOutline: true
                })
              ),
              mustContain && mustContain !== '' && _react2.default.createElement(
                'button',
                { className: 'search-bar-advanced-button-delete-input', onClick: this.deleteAdvancedSearchInput('mustContain') },
                _react2.default.createElement(Close, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'search-bar-advanced-row' },
              _react2.default.createElement(
                'div',
                { className: 'search-bar-advanced-label' },
                ' ',
                lexique.canContain
              ),
              _react2.default.createElement(
                'div',
                { className: 'search-bar-advanced-input' },
                _react2.default.createElement(_Input2.default, {
                  autoFocus: autoFocus,
                  value: canContain,
                  onChange: this.updateInputValue('canContain'),
                  disabled: disabled,
                  onEnterPress: this.onEnterPress,
                  onKeyPress: this.onKeyPress,
                  noOutline: true
                })
              ),
              canContain && canContain !== '' && _react2.default.createElement(
                'button',
                { className: 'search-bar-advanced-button-delete-input', onClick: this.deleteAdvancedSearchInput('canContain') },
                _react2.default.createElement(Close, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'search-bar-advanced-row' },
              _react2.default.createElement(
                'div',
                { className: 'search-bar-advanced-label' },
                ' ',
                lexique.mustNotContain,
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: 'search-bar-advanced-input' },
                _react2.default.createElement(_Input2.default, {
                  autoFocus: autoFocus,
                  value: mustNotContain,
                  onChange: this.updateInputValue('mustNotContain'),
                  disabled: disabled,
                  onEnterPress: this.onEnterPress,
                  onKeyPress: this.onKeyPress,
                  noOutline: true
                })
              ),
              mustNotContain && mustNotContain !== '' && _react2.default.createElement(
                'button',
                { className: 'search-bar-advanced-button-delete-input', onClick: this.deleteAdvancedSearchInput('mustNotContain') },
                _react2.default.createElement(Close, null)
              )
            )
          ),
          _react2.default.createElement(_AdvancedSearchFilter2.default, {
            filters: filters,
            onChangeFilters: onChangeFilters
          }),
          _react2.default.createElement(
            'div',
            { className: 'search-bar-advanced-submit' },
            _react2.default.createElement(_Button2.default, {
              onClick: this.doAdvancedSearch,
              label: lexique.search.toUpperCase()
            })
          )
        )
      );
    }
  }]);

  return AdvancedSearch;
}(_react.PureComponent);

exports.default = AdvancedSearch;